module.exports = __webpack_public_path__ + "img/honer8.9525a3cd.jpg";